// extracted by mini-css-extract-plugin
export var attachButton = "_ds-8";
export var sendButton = "_ds-2";
export var sendDisabled = "_ds-4";
export var sendEnabled = "_ds-3";
export var sendIcon = "_ds-6";
export var sendIconDisabled = "_ds-7";
export var sendStreaming = "_ds-5";
export var textarea = "_ds-1";
export var wrapper = "_ds-0";